import { useCan, useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { sortChecklistsByName } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

export const useDealerChecklistsQuery = () => {
  const { selectedDealer } = useSelectedDealer();
  const canListDealers = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Dealers);

  return useTypedQuery({
    queryKey: ChecklistsDashboardQueryKeys.dealerChecklists(selectedDealer?.id),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.checklists ?? [],
    select: sortChecklistsByName,
    enabled: !!selectedDealer?.id && canListDealers
  });
};
